const PLACEHOLDERS = {
  NA: 'N/A',
  DASH: '—',
  NO_RECORDS: 'No records found',
  /** An event that has not happened yet. `DASH` is a value we do not have; this is one there is not. */
  NEVER: 'Never'
} as const

const DEFAULT_COLORS = [
  'oklch(0.6547 0.1579 254.17)', // Astronaut 500, a strong and classic blue
  'oklch(0.7229 0.1911 149.78)', // Green 500, a standard, vibrant green for success
  'oklch(0.6368 0.2078 25.33)', // Red 500, a classic, bold red for errors
  'oklch(0.6074 0.2242 303.44)', // Mystic Purple, a rich and energetic purple
  'oklch(0.7611 0.1586 76.02)', // Yellow 500, a rich golden yellow
  'oklch(0.9054 0.1546 194.77)', // Aqua / Cyan, a pure, tech-focused teal
  'oklch(0.6481 0.1005 355.55)', // Blossom 500, a muted dusty rose or deep pink
  'oklch(0.7304 0.1864 52.57)', // Blazing Orange, a bright and warm accent
  'oklch(0.7098 0.1505 267.43)', // Lighter Blue, a softer, more accessible blue
  'oklch(0.8771 0.2333 150.02)', // Electric Green, a high-visibility, neon-like green
  'oklch(0.6216 0.2069 16.17)', // Darker Radiant Red, a deeper variant
  'oklch(0.5576 0.0419 270.05)', // Charade 500, a muted, neutral grey-blue
  'oklch(0.8868 0.1822 95.33)', // Sunny Yellow, a pure, bright yellow for highlights
  'oklch(0.7002 0.2901 324.59)', // Vivid Magenta, a striking, neon-like accent
  'oklch(0.3808 0.0472 272.8)', // Grey Blue, for subtle lines and borders
  'oklch(0.5982 0.2176 268.13)', // Nexus Blue, a vivid and electric blue accent
  'oklch(0.924 0.0146 264.5)', // Off-White, a soft highlight color
  'oklch(0.6676 0.0501 273.04)' // Light Grey-Blue, for secondary text or icons
] as const

// Selects a color from a palette, safely cycling within its bounds
export const getPaletteColor = (index: number, palette: readonly string[] = DEFAULT_COLORS) => {
  const safeIndex = Number.isFinite(index) && index >= 0 ? index : 0
  return palette[safeIndex % palette.length] as (typeof DEFAULT_COLORS)[number]
}

export { PLACEHOLDERS, DEFAULT_COLORS }
